import { Charts } from './Charts';
import ProfessionalsChartsDataProvider from './contexts/ProfessionalsChartsDataContext';

const ProfessionalsWrapper = () => {
    return (
        <ProfessionalsChartsDataProvider>
            <Charts />
        </ProfessionalsChartsDataProvider>
    );
};

export default ProfessionalsWrapper;
